import IDream from "motw_core/Entity/IDream";
import * as React from "react";
import { WithAnimatedProgressBarAsync } from "source/app/presentation/Header/ProgressBar/LevelProgressBar/WithAnimatedProgressBar";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { dreamService } from "motw_core/Services/DreamService";
import { HandleDreamDifficultyQuickSelectionAsync } from "../QuickSelector/DreamDifficultyQuickSelector";

export function DreamReviewIcon({ dream }: { dream: IDream }) {
    const [icon, setIcon] = React.useState<EGlyphicon>(EGlyphicon["eye-open"]);

    if (!ShouldDreamBeReviewed(dream)) {
        return null;
    }

    return (
        <span
            style={{ color: `yellowgreen` }}
            data-tip="This dream needs to be reviewed. Click here to complete review"
        >
            <IconWithText
                iconSuffix={icon}
                whenClicked={() => {
                    setIcon(EGlyphicon["ok-circle"]);
                    const currentDifficulty = dream.difficulty;

                    WithAnimatedProgressBarAsync(() =>
                        HandleDreamDifficultyQuickSelectionAsync(
                            dream,
                            currentDifficulty,
                            false // without doing this, "ok" icon will not show up as the dream row will immediately re-render
                        )
                    );
                }}
                displayAsBlock={false}
            />
        </span>
    );
}

export function ShouldDreamBeReviewed(dream: IDream) {
    const dreamAgeInMinutes = dreamService.GetDreamAgeInMinutes(dream);
    return dreamAgeInMinutes > threeMonthsInMinutes;
}

const threeMonthsInMinutes = 90 * 24 * 60;
